
const Login = () => import("@/app/views/auth/views/Login");
const Register = () => import("@/app/views/auth/views/Register");
const CambiarContrasenya = () => import("@/app/views/auth/views/CambiarContrasenya");
const OlvidoContrasenya = () => import("@/app/views/auth/views/OlvidoContrasenya");
const ConfirmEmail = () => import("@/app/views/auth/views/ConfirmEmail");
const ExpiredLink = () => import("@/app/views/auth/views/ExpiredLink");
const DeletedClient = () => import("@/app/views/auth/views/DeletedClient");

const RegistroMain = () => import("@/app/views/auth/views/register/RegistroMain");
const Personal = () => import("@/app/views/auth/views/register/PersonalData");
// const PersonalB = () => import("@/app/views/auth/views/register/PersonalDataB");
const Password = () => import('@/app/views/auth/views/register/Password');
const Telefono = () => import("@/app/views/auth/views/register/Phone")
const CreditCard = () => import("@/app/views/auth/views/register/CreditCard")
const Access = () => import("@/app/views/auth/views/register/Access");


// const optionA = Math.random() < 0.5;
// console.error(optionA);

import Vue from 'vue';
Vue.prototype.$test = 'A'; // optionA ? 'A' : 'B';


const authRoutes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      auth: false
    }
  },
  // {
  //   path: "/register",
  //   name: "Registro",
  //   component: Register,
  //   meta: {
  //     auth: false
  //   }
  // },
  // {
  //   path: "/register/phone",
  //   name: "Registro",
  //   component: Telefono,
  //   meta: {
  //     auth: false
  //   }
  // },
  // {
  //   path: "/register/credit_card",
  //   name: "Registro",
  //   component: Register,
  //   meta: {
  //     auth: false
  //   }
  // },
  // {
  //   path: "/register/success",
  //   name: "Registro",
  //   component: Register,
  //   meta: {
  //     auth: false
  //   }
  // },

  // {
  //   path: "/clientes/personal",
  //   redirect: '/clientes',
  //   meta: {
  //     auth: false
  //   }
  // },
  {
    path: "/clientes",
    name: "registro-cliente",
    component: RegistroMain,
    // redirect: optionA ? "/clientes/personalA" : "/clientes/personalB",
    redirect: "/clientes/personal",
    meta: {
      auth: false
    },
    children: [
      {
        path: "personal",
        name: 'Personal',
        component: Personal,
        meta: {
          auth: false
        }
      },
      // {
      //   path: "personalA",
      //   name: 'Personal',
      //   component: Personal,
      //   meta: {
      //     auth: false
      //   }
      // },
      // {
      //   path: "personalB",
      //   name: 'Personal',
      //   component: PersonalB,
      //   meta: {
      //     auth: false
      //   }
      // },
      {
        path: 'password',
        name: 'Contraseña',
        component: Password,
        meta: { auth: false }
      },
      {
        path: "phone",
        name: 'Telefono',
        component: Telefono,
        meta: {
          auth: false
        }
      },
      {
        path: "phone/:token",
        name: 'Telefono',
        component: Telefono,
        meta: {
          auth: false
        }
      },
      {
        path: "credit_card",
        name: 'CreditCard',
        component: CreditCard,
        meta: {
          auth: false
        }
      },
      {
        path: "acceso",
        name: 'Acceso',
        component: Access, // Acceso
        meta: {
          auth: false
        }
      },
      // {
      //   path: "registro/:id",
      //   component: RegistroCompleto
      // }
    ]
  },
  {
    path: "/restablecer-contrasenya/:token",
    name: "cambiar-contrasenya",
    component: CambiarContrasenya,
    meta: {
      auth: false
    }
  },
  {
    path: "/restablecer-contrasenya",
    name: "restablecer-contrasenya",
    component: OlvidoContrasenya,
    meta: {
      auth: false
    }
  },
  {
    path: "/email/verify/success",
    name: "email-verificado",
    component: ConfirmEmail,
    meta: {
      auth: false
    }
  },
  {
    path: "/email/verify/success/:already",
    name: "email-ya-verificado",
    component: ConfirmEmail,
    meta: {
      auth: false
    }
  },
  {
    path: "/verify/link-expired",
    name: "expiredLink",
    component: ExpiredLink,
    meta: {
      auth: false
    }
  },
  {
    path: "/auth/eliminada",
    name: "cuentaBorrada",
    component: DeletedClient,
    meta: {
      auth: false
    }
  }

];

export default authRoutes;
